<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Conductores</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Administrativo</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Conductores</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <!-- Header con botones de acción -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card shadow-sm border-0"
                  :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'"
                >
                  <div
                    class="card-header border-0 py-3"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5
                          class="mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-users me-2 text-primary"></i>
                          Gestión de Conductores
                        </h5>
                        <p class="mb-0 text-muted small">
                          Administra la información de conductores y sus
                          documentos
                        </p>
                      </div>
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-outline-info"
                          @click="pivotTable()"
                          v-if="
                            $store.getters.can('admin.conductores.pivotTable')
                          "
                          data-bs-toggle="tooltip"
                          title="Vista de tabla dinámica"
                        >
                          <i class="fas fa-scroll me-1"></i>
                          Tabla Dinámica
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-success"
                          data-toggle="modal"
                          data-target="#modal_form_conductor_export"
                          v-if="$store.getters.can('admin.conductores.export')"
                          data-bs-toggle="tooltip"
                          title="Exportar a Excel"
                        >
                          <i class="far fa-file-excel me-1"></i>
                          Exportar
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          v-if="$store.getters.can('admin.conductores.create')"
                          @click="create()"
                          data-bs-toggle="tooltip"
                          title="Crear nuevo conductor"
                        >
                          <i class="fas fa-plus me-1"></i>
                          Nuevo Conductor
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  :class="
                    $store.getters.getDarkMode
                      ? 'bg-dark border-secondary'
                      : 'bg-white'
                  "
                >
                  <div
                    class="card-header py-2"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <h6
                      class="mb-0"
                      :class="
                        $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                      "
                    >
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- Filtro Tipo Documento -->
                      <div class="col-md-2 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-id-card me-1"></i>
                          Tipo Doc.
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.tipo_documento"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="tipo_documento in listasForms.tipo_documentos"
                            :key="tipo_documento.numeracion"
                            :value="tipo_documento.numeracion"
                          >
                            {{ tipo_documento.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Filtro Número Documento -->
                      <div class="col-md-2 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-hashtag me-1"></i>
                          N° Documento
                        </label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.numero_documento"
                          @keyup="getIndex()"
                          placeholder="Buscar número..."
                        />
                      </div>

                      <!-- Filtro Nombre -->
                      <div class="col-md-3 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-user me-1"></i>
                          Nombre
                        </label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.nombre"
                          @keyup="getIndex()"
                          placeholder="Buscar nombre..."
                        />
                      </div>

                      <!-- Filtro Estado -->
                      <div class="col-md-2 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Filtro Líneas de Negocio -->
                      <div class="col-md-3 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-briefcase me-1"></i>
                          Líneas de Negocio
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="linea_negocio"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.lineas_negocio"
                          :filterable="true"
                          multiple
                          @input="getIndex()"
                          placeholder="Seleccionar..."
                        ></v-select>
                      </div>

                      <!-- Filtro Estado Documentación -->
                      <div
                        class="col-md-3 form-group"
                        v-if="linea_negocio.length != 0 || !linea_negocio"
                      >
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-file-alt me-1"></i>
                          Doc. (Estado)
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado_documentacion"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option value="Vencidos">Vencido</option>
                          <option value="Pendientes">Pendiente</option>
                          <option value="No verificados">No verificado</option>
                          <option value="Verificados">Verificado</option>
                          <option value="Sin_paquete">Sin paquete</option>
                          <option value="con_alertas"
                            >Con alertas (cualquiera)</option
                          >
                        </select>
                      </div>

                      <!-- Filtro Empresa -->
                      <div class="col-md-3 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="listasForms.selct_empresa"
                          placeholder="Buscar empresa..."
                          label="razon_social"
                          class="form-control form-control-sm p-0"
                          :options="empresas"
                          :filterable="false"
                          @search="buscarEmpresas"
                          @input="getIndex()"
                        ></v-select>
                      </div>

                      <!-- Botón limpiar filtros -->
                      <div class="col-md-2 form-group mt-2 pt-3">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm w-100"
                          @click="limpiarFiltros()"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div
              class="card"
              :class="
                $store.getters.getDarkMode
                  ? 'bg-dark border-secondary'
                  : 'bg-white'
              "
            >
              <div
                class="card-header py-2"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6
                    class="mb-0"
                    :class="
                      $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                    "
                  >
                    <i class="fas fa-table me-2"></i>
                    Lista de Conductores
                  </h6>
                  <span class="badge bg-primary">
                    {{ conductores.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive text-nowrap">
                  <table
                    class="table table-hover table-striped mb-0 table-bordered"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''"
                  >
                    <thead
                      class="text-center bg-dark"
                      :class="
                        $store.getters.getDarkMode
                          ? 'table-dark'
                          : 'table-light'
                      "
                    >
                      <tr>
                        <th class="text-center" style="width: 80px">
                          <i class="fas fa-image"></i>
                        </th>
                        <th>
                          <i class="fas fa-id-card me-1"></i>
                          Tipo Doc.
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('numero_documento')"
                          :title="tooltipSort('numero_documento')"
                        >
                          <i class="fas fa-hashtag me-1"></i>
                          N° Documento
                          <span class="ms-1 small text-muted">{{
                            sortIcon("numero_documento")
                          }}</span>
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('nombre')"
                          :title="tooltipSort('nombre')"
                        >
                          <i class="fas fa-user me-1"></i>
                          Nombre Completo
                          <span class="ms-1 small text-muted">{{
                            sortIcon("nombre")
                          }}</span>
                        </th>
                        <th>
                          <i class="fas fa-phone me-1"></i>
                          Teléfono
                        </th>
                        <th>
                          <i class="fas fa-id-badge me-1"></i>
                          Categoría Lic.
                        </th>
                        <th>
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Localidad
                        </th>
                        <th>
                          <i class="fas fa-briefcase me-1"></i>
                          Líneas
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('empresa')"
                          :title="tooltipSort('empresa')"
                        >
                          <i class="fas fa-building me-1"></i>
                          Empresa
                          <span class="ms-1 small text-muted">{{
                            sortIcon("empresa")
                          }}</span>
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('estado_documentacion')"
                          :title="tooltipSort('estado_documentacion')"
                        >
                          <i class="fas fa-file-alt me-1"></i>
                          Documentos
                          <span class="ms-1 small text-muted">{{
                            sortIcon("estado_documentacion")
                          }}</span>
                        </th>
                        <th
                          class="text-center"
                          role="button"
                          @click="toggleSort('estado')"
                          :title="tooltipSort('estado')"
                        >
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                          <span class="ms-1 small text-muted">{{
                            sortIcon("estado")
                          }}</span>
                        </th>
                        <th class="text-center">
                          <i class="fas fa-cogs me-1"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in conductores.data" :key="item.id">
                        <td class="text-center">
                          <a
                            v-if="item.link_fotografia"
                            :href="uri_docs + item.link_fotografia"
                            target="_blank"
                            class="d-inline-block"
                          >
                            <img
                              :src="uri_docs + item.link_fotografia"
                              alt="Conductor"
                              class="rounded shadow-sm"
                              style="
                                width: 50px;
                                height: 50px;
                                object-fit: cover;
                              "
                            />
                          </a>
                          <div
                            v-else
                            class="d-flex align-items-center justify-content-center rounded"
                            :class="
                              $store.getters.getDarkMode
                                ? 'bg-secondary'
                                : 'bg-light'
                            "
                            style="width: 50px; height: 50px; margin: 0 auto"
                          >
                            <i class="fas fa-user text-muted"></i>
                          </div>
                        </td>
                        <td>
                          <span class="badge bg-info">{{ item.tipoDoc }}</span>
                        </td>
                        <td>
                          <span
                            class="fw-bold"
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ item.numero_documento }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ item.nombres + " " + item.apellidos }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ item.celular_principal }}
                          </span>
                        </td>
                        <td>
                          <span class="badge bg-secondary">{{
                            item.categoriaLic
                          }}</span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ item.loc }}
                          </span>
                        </td>
                        <td>
                          <div
                            v-if="
                              item.lineas_negocio && item.lineas_negocio.length
                            "
                            class="d-flex flex-column gap-1"
                          >
                            <span
                              v-for="lineas in item.lineas_negocio"
                              :key="lineas.id"
                              class="badge bg-navy mt-1"
                            >
                              {{ lineas.nombre }}
                            </span>
                          </div>
                          <span v-else class="text-muted small text-center"
                            >Sin líneas</span
                          >
                        </td>
                        <td>
                          <div
                            v-if="item.empresas && item.empresas.length > 0"
                            class="d-flex flex-column gap-1"
                          >
                            <span
                              v-for="empresas in item.empresas"
                              :key="empresas.id"
                              :class="
                                $store.getters.getDarkMode
                                  ? 'text-light'
                                  : 'text-dark'
                              "
                            >
                              {{ empresas.razon_social }}
                            </span>
                          </div>
                          <span v-else class="text-muted small"
                            >Sin empresa</span
                          >
                        </td>
                        <td>
                          <div
                            v-if="
                              item.lineas_negocio &&
                                item.lineas_negocio.length > 0
                            "
                          >
                            <div
                              v-for="linea in item.estado_documentos_lineas"
                              :key="linea.linea_negocio_id"
                              class="mb-1"
                            >
                              <!-- Nombre de la línea -->
                              <div
                                class="small fw-bold text-muted mb-1 text-center"
                              >
                                {{ linea.linea_negocio }}
                              </div>

                              <!-- Badge de estado con tooltip -->
                              <span
                                v-if="linea.estado === 'OK'"
                                class="d-flex flex-column gap-1"
                                title="Todos los documentos verificados"
                              >
                                <span class="badge bg-success"
                                  ><i class="fas fa-check me-1"></i>
                                  Verificados</span
                                >
                              </span>

                              <span
                                v-else-if="linea.estado === 'SIN_PAQUETE'"
                                class="d-flex flex-column gap-1"
                                title="Sin paquete de documentos asignado"
                              >
                                <span class="badge bg-secondary">
                                  <i class="fas fa-box-open me-1"></i> Sin
                                  paquete</span
                                >
                              </span>

                              <span v-else class="d-flex flex-column gap-1">
                                <span
                                  v-if="linea.vencidos.length > 0"
                                  class="badge bg-danger"
                                  :title="
                                    'Vencidos: ' + linea.vencidos.join(', ')
                                  "
                                >
                                  <i
                                    class="fas fa-exclamation-triangle me-1"
                                  ></i>
                                  Vencidos ({{ linea.vencidos.length }})
                                </span>
                                <span
                                  v-if="linea.pendientes.length > 0"
                                  class="badge bg-warning text-dark"
                                  :title="
                                    'Pendientes: ' + linea.pendientes.join(', ')
                                  "
                                >
                                  <i class="fas fa-clock me-1"></i>
                                  Pendientes ({{ linea.pendientes.length }})
                                </span>
                                <span
                                  v-if="linea.no_verificados.length > 0"
                                  class="badge bg-info text-dark"
                                  :title="
                                    'No verificados: ' +
                                      linea.no_verificados.join(', ')
                                  "
                                >
                                  <i class="fas fa-question me-1"></i>
                                  No verificados ({{
                                    linea.no_verificados.length
                                  }})
                                </span>
                              </span>
                            </div>
                          </div>

                          <!-- Conductor sin líneas asignadas -->
                          <div
                            v-else
                            class="d-flex flex-column align-items-center gap-1"
                          >
                            <div
                              class="small fw-bold text-muted mb-1 text-center"
                            >
                              No tiene
                            </div>
                            <span
                              class="badge bg-danger"
                              :title="'Linea de negocio no encontrada'"
                            >
                              <i class="fas fa-exclamation-triangle me-1"></i>
                              Linea de negocio asociada
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            data-toggle="modal"
                            data-target="#modal-form-estado"
                            style="cursor: pointer"
                            v-if="
                              $store.getters.can(
                                'admin.conductores.editStatusHSE',
                              )
                            "
                            v-bind:class="[
                              item.estado == 1 ? 'bg-success' : 'bg-danger',
                            ]"
                            @click="llenarModal(item)"
                          >
                            {{ item.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                          </span>
                          <span
                            class="badge"
                            v-else
                            v-bind:class="[
                              item.estado == 1 ? 'bg-success' : 'bg-danger',
                            ]"
                          >
                            {{ item.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                $store.getters.can(
                                  'admin.conductores.editarTransportadora',
                                ) && !admin
                              "
                              @click="edit(item, 3)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-info"
                              v-else-if="
                                $store.getters.can('admin.conductores.show')
                              "
                              @click="edit(item, 1)"
                              title="Ver detalles"
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                empresa.length > 0 &&
                                  item.tipo_propiedad == 1 &&
                                  item.empresas.length > 0 &&
                                  empresa[0].id == item.empresas[0].id &&
                                  $store.getters.can('admin.conductores.edit')
                              "
                              @click="edit(item, 2)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-else-if="
                                (empresa.length === 0 ||
                                  item.tipo_propiedad != 1) &&
                                  $store.getters.can('admin.conductores.edit')
                              "
                              @click="edit(item, 2)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              data-toggle="modal"
                              data-target="#modal-historial-estado"
                              v-if="
                                $store.getters.can('admin.conductores.show')
                              "
                              @click="
                                llenarModalHistorial('App\\Conductor', item.id)
                              "
                              title="Ver historial"
                            >
                              <i class="fas fa-history"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                  v-if="!conductores.data || conductores.data.length === 0"
                  class="text-center py-5"
                >
                  <h5 class="text-muted">No hay conductores para mostrar</h5>

                  <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                    <p class="mt-2 text-muted">Cargando Conductores..</p>
                  </div>
                </div>
              </div>
              <div
                class="card-footer border-0"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="conductores.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del
                      <span class="fw-bold text-primary">{{
                        conductores.from
                      }}</span>
                      al
                      <span class="fw-bold text-primary">{{
                        conductores.to
                      }}</span>
                      de un total:
                      <span class="fw-bold text-primary">{{
                        conductores.total
                      }}</span>
                      registros
                    </p>
                  </div>
                  <div v-else>
                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="conductores"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    align="right"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ConductorEstado ref="ConductorEstado" />
        <ConductorExport ref="ConductorExport" />
        <HistorialEstado ref="HistorialEstado" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import ConductorEstado from "./ConductorEstado";
import ConductorExport from "./ConductorExport";
import HistorialEstado from "../historialEstado/HistorialEstado";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";

export default {
  name: "Conductores",
  components: {
    pagination,
    vSelect,
    ConductorEstado,
    HistorialEstado,
    ConductorExport,
    Loading,
  },
  data() {
    return {
      linea_negocio: [],
      empresas: [],
      user: null,
      admin: null,
      empresa: this.$store.getters.getUser.empresas,
      tipo_usuario_cambia_estado: null,
      storageKeyFiltros: "admin_conductor_filtros",
      cargando: false,
      filtros: {
        tipo_documento: null,
        numero_documento: null,
        nombre: null,
        empresa_id: null,
        estado: null,
        estado_documentacion: "",
        sort_by: null,
        sort_dir: "asc",
      },
      conductores: {},
      listasForms: {
        tipo_documentos: [],
        estados: [],
        lineas_negocio: [],
        selct_empresa: [],
      },
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  methods: {
    toggleSort(col) {
      if (!col) return;
      // Ciclo: sin orden -> asc -> desc -> sin orden
      if (this.filtros.sort_by !== col) {
        this.filtros.sort_by = col;
        this.filtros.sort_dir = "asc";
      } else if (this.filtros.sort_dir === "asc") {
        this.filtros.sort_dir = "desc";
      } else {
        this.filtros.sort_by = null;
        this.filtros.sort_dir = "asc";
      }
      this.getIndex(1);
    },
    sortIcon(col) {
      if (this.filtros.sort_by !== col) return "";
      return this.filtros.sort_dir === "asc" ? "▲" : "▼";
    },
    tooltipSort(col) {
      if (this.filtros.sort_by !== col) return "Ordenar ascendente";
      return this.filtros.sort_dir === "asc"
        ? "Ordenar descendente"
        : "Quitar orden";
    },
    getStoredFiltros() {
      try {
        const raw = sessionStorage.getItem(this.storageKeyFiltros);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    setStoredFiltros() {
      try {
        const payload = {
          filtros: { ...this.filtros },
          linea_negocio: Array.isArray(this.linea_negocio)
            ? this.linea_negocio
                .map((l) =>
                  l && l.id ? { id: l.id, nombre: l.nombre || "" } : null,
                )
                .filter(Boolean)
            : [],
          selct_empresa:
            this.listasForms.selct_empresa && this.listasForms.selct_empresa.id
              ? {
                  id: this.listasForms.selct_empresa.id,
                  razon_social:
                    this.listasForms.selct_empresa.razon_social || "",
                }
              : null,
        };
        sessionStorage.setItem(this.storageKeyFiltros, JSON.stringify(payload));
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    clearStoredFiltros() {
      try {
        sessionStorage.removeItem(this.storageKeyFiltros);
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    getIndex(page = 1) {
      this.cargando = true;
      if (this.$store.state.user) {
        const administrador = this.$store.state.user.roles.find(
          (administrador) => administrador.id === 1,
        );
        if (administrador) {
          this.admin = administrador.id;
        }
      }
      if (this.$store.getters.can("admin.conductores.editStatusInspector")) {
        this.tipo_usuario_cambia_estado = `Inspector`;
      }
      if (this.$store.getters.can("admin.conductores.editStatusHSE")) {
        this.tipo_usuario_cambia_estado = `HSE`;
      }
      const stored = this.getStoredFiltros();
      if (stored && stored.filtros) {
        Object.assign(this.filtros, stored.filtros);
        this.linea_negocio = stored.linea_negocio || [];
        this.listasForms.selct_empresa = stored.selct_empresa || null;
        this.clearStoredFiltros();
      } else {
        this.filtros.empresa_id = null;
        this.filtros.lineas_negocio = [];
        this.linea_negocio.forEach((linea) => {
          this.filtros.lineas_negocio.push(linea.id);
        });
        if (this.listasForms.selct_empresa) {
          this.filtros.empresa_id = this.listasForms.selct_empresa.id;
        }
      }
      axios
        .get("/api/admin/conductores?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.conductores = response.data;
        })
        .catch(() => {
          // mantener UX consistente: si falla, apagar loader
        })
        .finally(() => {
          this.cargando = false;
        });
    },

    getLineasNegocio() {
      axios.get("/api/admin/lineasNegocios/lista").then((response) => {
        this.listasForms.lineas_negocio = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
    getTiposIdentificacion() {
      axios.get("/api/lista/6").then((response) => {
        this.listasForms.tipo_documentos = response.data;
      });
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroy(idConductor) {
      this.$swal({
        title: "Esta seguro de eliminar este Conductor?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, ElimInar!",
      }).then((result) => {
        // <--
        if (result.value) {
          axios.delete("/api/admin/conductores/" + idConductor).then(() => {
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "Se elimino el Conductor exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          });
        }
      });
    },

    llenarModal(conductor) {
      if (
        this.$store.getters.can("admin.conductores.editStatusHSE") ||
        this.$store.getters.can("admin.conductores.editStatusInspector")
      ) {
        this.$refs.ConductorEstado.form_estado = {};
        this.$refs.ConductorEstado.llenar_modal(
          conductor,
          this.tipo_usuario_cambia_estado,
        );
      }
    },

    llenarModalHistorial(entidad, entidad_id) {
      if (this.$store.getters.can("admin.conductores.show")) {
        this.$refs.HistorialEstado.llenar_modal(entidad, entidad_id);
      }
    },

    create() {
      return this.$router.push({
        name: "/Admin/ConductorForm",
        params: { accion: "Crear", id: 0 },
      });
    },

    edit(conductor, opcion) {
      this.setStoredFiltros();
      return this.$router.push({
        name: "/Admin/ConductorForm",
        params: {
          accion: "Editar",
          data_edit: conductor,
          id: conductor.id,
          opcion: opcion,
        },
      });
    },

    pivotTable() {
      return this.$router.push({
        name: "/Admin/ConductorPivotTable",
      });
    },

    getMsg() {
      if (this.$route.params.msg) {
        this.$swal({
          icon: "success",
          title: this.$route.params.msg,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }
    },

    limpiarFiltros() {
      this.filtros = {
        tipo_documento: null,
        numero_documento: null,
        nombre: null,
        estado: null,
        empresa_id: null,
        estado_documentacion: null,
      };
      this.linea_negocio = [];
      this.listasForms.selct_empresa = null;
      this.conductores = {};
      this.getIndex();
    },
  },

  mounted() {
    this.getIndex();
    this.getEstados();
    this.getTiposIdentificacion();
    this.getMsg();
    this.getLineasNegocio();
  },
};
</script>
